import { isEqual } from "es-toolkit";
import React, { useEffect, useRef, useState } from "react";
import Talker from "../../utils/Talker";

const TalkerFrame = ({ data, src }) => {
  const [frame, setFrame] = useState();
  const talkerRef = useRef();
  const dataRef = useRef(data);

  useEffect(() => {
    if (!frame) return undefined;

    const talker = new Talker(frame.contentWindow, "*");
    talker.onMessage = (message) => {
      if (message.namespace === "init") {
        message.respond(dataRef.current);
      }
    };
    talkerRef.current = talker;

    return () => {
      talker.destroy();
      talkerRef.current = null;
    };
  }, [frame]);

  useEffect(() => {
    if (talkerRef.current && !isEqual(data, dataRef.current)) {
      talkerRef.current.send("update", data);
    }
    dataRef.current = data;
  }, [data]);

  const frameStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  };

  return (
    <iframe
      id="widget-frame"
      frameBorder="0"
      scrolling="no"
      style={frameStyle}
      src={src}
      ref={setFrame}
    />
  );
};

export default TalkerFrame;
